import React from "react";
import PropTypes from "prop-types";
import "./ResetButton.css";
import ButtonForm from "../../ButtonForm/ButtonForm";

const ResetButton = ({
  id = "",
  title = "Reset",
  disabled = false,
  ...rest
}) => {
  return (
    <ButtonForm
      type="button"
      id={id}
      disabled={disabled}
      value={title}
      className="btn-reset btn-secondary"
      {...rest}
    />
  );
};

ResetButton.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  disabled: PropTypes.bool,
};

export default ResetButton;
